import type { BodyRouteParamsRequest } from '@pba/react-utils';
import { changeRequest } from 'features/change-requests';

type RequestToJoinCommunityBody = {
  reason?: string;
};

type RequestToJoinCommunityRouteParams = {
  id: string;
};

/**
 * @deprecated Duplicate of `changeRequest` from the change-requests feature (`kind: 'community_request_to_join'`). Call that service directly and drop this wrapper.
 */
export const requestToJoinCommunity = async ({
  body: { reason },
  routeParams: { id },
}: BodyRouteParamsRequest<RequestToJoinCommunityBody, RequestToJoinCommunityRouteParams>) =>
  changeRequest({
    body: {
      kind: 'community_request_to_join',
      meta: {
        reason_to_join: reason,
      },
      subject_id: id,
      subject_type: 'Community',
    },
  });
